import {ApiClient} from './api'

export class AdyenPaymentMethodsService {
    baseUrl = '/mobify/api/adyen/paymentMethods'
    apiClient = null

    constructor(token, site) {
        this.apiClient = new ApiClient(this.baseUrl, token, site)
    }

    async fetchPaymentMethods(customerId, locale, preferredPayment) {
        const res = await this.apiClient.get({
            queryParams: {locale: locale.id},
            headers: {
                customerid: customerId,
            },
        })
        if (res.status >= 300) {
            throw new Error(res)
        } else {
            let responseData = await res.json()

            // If there is a preferred payment method, put it first to show it as the default method at checkout
            if (preferredPayment && responseData.storedPaymentMethods) {
                const preferredPaymentMethod = responseData.storedPaymentMethods.find(
                    (method) => method.id === preferredPayment,
                )
                const otherPaymentMethods = responseData.storedPaymentMethods.filter(
                    (method) => method.id !== preferredPayment,
                )

                responseData.storedPaymentMethods = preferredPaymentMethod
                    ? [preferredPaymentMethod, ...otherPaymentMethods]
                    : otherPaymentMethods
            }

            return responseData
        }
    }
}
